app.factory('messageService', ['$q', '$interval', '$http', '$rootScope', 'gameService', 'analyticsService', function ($q, $interval, $http, $rootScope, gameService, analyticsService) {
	var service = this;

	service.unreadCount = 0;
	service.lastRead = 0;
	service.started = false;
	service.paused = false;

	service.startAndSyncImmediately = function() {
		console.log("messageService: startAndSyncImmediately called...");

		if (service.started) {
			return $q(function(resolve, reject) {
				resolve();
			});
		}

		// Sync once a while, at the interval specified in the config.
		$interval(function() {
			if (service.paused) {
				return;
			}
			service.fullSync();
		}, (gameService.config.messageServiceUpdateIntervalSecs || 30) * 1000.0);

		console.log("messageService: now running.");
		service.started = true;

		// Sync now.
		return service.fullSync();
	}

	service.fullSync = function(opts) {
		return $q(function(resolve, reject) {
			var url = "/api/game/message";
			$http.get(url).then(function(response) {
					service.messages = response.data.messages;
					service.updateUnreadCount();
					$rootScope.$broadcast('messageServiceUpdated');
					console.log("messageService: full syncc done!");
					resolve();
				},
				function() {
					reject();
				});
		});
	}

	service.updateUnreadCount = function() {
		var unreadCount = 0;

		for (var i = 0; i < service.messages.length; i++) {
			var message = service.messages[i];
			if (service.lastRead <= message.timestamp) {
				unreadCount += 1;
			}
		}

		service.unreadCount = unreadCount;
	}

	service.setLastRead = function() {
		service.updateUnreadCount();
		service.lastRead = parseInt((new Date()).getTime() / 1000.0); // current unix timestamp
	}

	service.sendMessage = function(msgObj) {
		return $q(function(resolve, reject) {
			$http.post('/api/game/message', msgObj).then(function(response) {
				service.messages = response.data.messages;
				$rootScope.$broadcast('messageServiceUpdated');
				analyticsService.event("teacher_message_sent");
				resolve();
			}, function() {
				reject();
			});
		});

		return $http.post('/api/game/message', msgObj);
	}

	return service;
}]);